import axios from "axios";
import config from "../config/config";
import { buildAuthHeaders, buildAuthRequestConfig } from "../utils/authSession";

export function authHeaders() {
  return buildAuthHeaders();
}

export function extractPlatformAccessBlock(error) {
  const data = error?.response?.data;
  if (!data || String(data.code || "").trim().toLowerCase() !== "platform_access_blocked") {
    return null;
  }
  return {
    code: data.code,
    action: data.action || null,
    role: data.role || null,
    scope: data.scope || null,
    message: data.message || data.detail || "Der Plattformzugang ist derzeit eingeschraenkt.",
    startsAt: data.startsAt || null,
    endsAt: data.endsAt || null,
    timezone: data.timezone || "Europe/Berlin",
    matchedBy: data.matchedBy || null,
  };
}

export async function getPublicPlatformAccessStatus({ action, role }) {
  const response = await axios.get(`${config.API_BASE_URL}/api/platform-access/public`, {
    params: {
      action,
      role: role || undefined,
    },
    withCredentials: true,
  });
  return response.data || {};
}

export async function getMyPlatformAccessStatus() {
  try {
    const response = await axios.get(`${config.API_BASE_URL}/api/platform-access/me`, {
      ...buildAuthRequestConfig({ headers: authHeaders() }),
    });
    return response.data || {};
  } catch (error) {
    const status = Number(error?.response?.status || 0);
    if (status && status !== 404 && status < 500) {
      throw error;
    }
    const fallbackResponse = await axios.get(`${config.API_BASE_URL}/api/me`, {
      ...buildAuthRequestConfig({ headers: authHeaders() }),
    });
    return fallbackResponse.data || {};
  }
}

export async function getAdminPlatformAccessStatus() {
  const response = await axios.get(`${config.API_BASE_URL}/api/admin/platform-access`, {
    ...buildAuthRequestConfig({ headers: authHeaders() }),
  });
  return response.data || {};
}

export async function saveAdminPlatformAccessRule({ scope, role, payload }) {
  const url = scope === "global"
    ? `${config.API_BASE_URL}/api/admin/platform-access/global`
    : `${config.API_BASE_URL}/api/admin/platform-access/roles/${encodeURIComponent(role)}`;
  const response = await axios.put(url, payload, {
    ...buildAuthRequestConfig({ headers: authHeaders() }),
  });
  return response.data || {};
}
